import { useMemo } from "react";

import { isNotEmpty, isEmpty, isString, isArray } from "2g-utils-common";
import { useDataLoader } from "2g-hooks/fetch";
import { useDidUpdateEffect } from "2g-hooks";
import { useTokenVariable } from "2g-fetch-provider";

import { UZIVATEL } from "b2b/api/paths";

export default function useUserInfo() {
  const [token] = useTokenVariable();
  const {
    data: { uzivatel, zakaznik } = {},
    load,
    loading,
    loaded,
    restore,
    error
  } = useDataLoader({
    url: UZIVATEL.userInfo(),
    method: "get"
  });

  const first = uzivatel?.jmeno || "-";
  const last = uzivatel?.prijmeni || "-";
  const initials = `${first.charAt(0)}${last.charAt(0)}`;

  const isUserInRole = roles => {
    roles = isString(roles) ? [roles] : roles;

    return isArray(roles)
      ? roles.some(role => uzivatel?.role.includes(role))
      : false;
  };

  useDidUpdateEffect(() => {
    restore();
    token && load();
  }, [token]);

  return useMemo(
    () => ({
      isAuthenticated: isNotEmpty(token),
      isAuthorized: isNotEmpty(token) && isNotEmpty(uzivatel),
      showDialog: loading || isEmpty(uzivatel),
      userInfo: uzivatel
        ? {
            ...uzivatel,
            initials,
            isUserInRole,
            fullName: `${uzivatel?.jmeno || ""} ${uzivatel?.prijmeni || ""}`
          }
        : undefined,
      zakaznik,
      loading,
      loaded,
      error
    }),
    [uzivatel, zakaznik, loading, loaded, error, token]
  );
}
